var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arisk-testbar"},_vm._l((_vm.clients),function(client,i){return _c('div',{key:'tc' + i,staticClass:"arisk-testbar-client",class:[
        {'arisk-testbar-client-border': i == 0 }
    ]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }